import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      directDID: null,
      dbSourceDirect: null
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getCompany",
      "getCompanyDID",
      "getFacilityDID",
      "getMaterialDID",
      "getBudgetDID",
      "getPlanDID",
      "getUserDID",
      "getAssetDID",
      "getMaintStrategyDID",
      "getMaintPlanDID",
      "getDocumentLogTag",
      "getDetail",
      "getDetailBasic",
      "getCurrentPage",
      "getDataSource",
      "getLogDID"
    ]),
    userDID() {
      return this.getUser.basic.did;
    },
    detailDID() {
      return this.getDetail.basic.did;
    },
    logDID() {
      return this.getLogDID;
    },
    db() {
      return firebase.firestore();
    },
    dbUser() {
      // eslint-disable-next-line
      return firebase.firestore().collection("user");
    },
    dbUserAccess() {
      // eslint-disable-next-line
      return this.db.collection("person").doc(this.getUserDID).collection("access");
    },
    dbUserAccessUndefined() {
      // eslint-disable-next-line
      return this.db.collection("person");
    },
    dbUserActions() {
      // eslint-disable-next-line
      return this.db.collection("person").doc(this.getUserDID).collection("action");
    },
    dbUserLog() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getUserDID).collection("log");
    },
    dbAdminReviewAccess() {
      // eslint-disable-next-line
      return firebase.firestore().collection("admin").doc("review").collection("access");
    },
    dbStats() {
      // eslint-disable-next-line
      return firebase.firestore().collection("stats");
    },
    dbRelps() {
      // eslint-disable-next-line
      return firebase.firestore().collection("relps");
    },
    dbCompany() {
      // eslint-disable-next-line
      return firebase.firestore().collection("company");
    },
    dbCompanyAccess() {
      // defensive test for sign in
      let did = "sign in";
      if (this.getDetail !== null && this.getDetail.basic.tag === "B3") {
        // used to search for actions assignees in company adatabase
        did = this.getDetail.link.cdid;
      } else if (this.getCompanyDID !== null) {
        did = this.getCompanyDID;
      } else {
        did = null;
      }
      // eslint-disable-next-line
      return this.db.collection("governance").doc(did).collection("access");
    },
    dbCompanyLog() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getCompanyDID).collection("log");
    },
    dbCompanyEquipment() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("equipment");
    },
    dbCompanyHazard() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("hazard");
    },
    dbCompanyProcedure() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("procedure");
    },
    dbCompanyProgram() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("program");
    },
    dbCompanyOrder() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("order");
    },
    dbMaintenanceCall() {
      // eslint-disable-next-line
      return this.db.collection("maintenance").doc(this.getMaintPlanDID).collection("calls");
    },
    dbCompanyOrderHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("order");
    },
    dbMaterialOrders() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getMaterialDID).collection("order");
    },
    dbBudgetOrders() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getBudgetDID).collection("order");
    },
    dbMaintenanceStrategyPlans() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getMaintStrategyDID).collection("plan");
    },
    dbCompanyIncident() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("incident");
    },
    dbCompanyIncidentHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("incident");
    },
    dbCompanyRisk() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("risk");
    },
    dbCompanyRiskHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("risk");
    },
    dbCompanyBudget() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("budget");
    },
    dbCompanyBudgetHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("budget");
    },
    dbCompanyPlan() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("plan");
    },
    dbCompanyPlanHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("plan");
    },
    dbCompanyPlanWork() {
      // eslint-disable-next-line
      return this.db.collection("plan").doc(this.getPlanDID).collection("work");
    },
    dbCompanyMaintenanceStrategy() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("strategy");
    },
    dbCompanyMaterial() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("material");
    },
    dbCompanyMaterialList() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("material list");
    },
    dbCompanyAction() {
      // eslint-disable-next-line
      return firebase.firestore().collection("governance").doc(this.getCompanyDID).collection("action");
    },
    dbCompanyActionHistory() {
      // eslint-disable-next-line
      return firebase.firestore().collection("history").doc(this.getCompanyDID).collection("action");
    },
    dbCompanyEngineering() {
      // eslint-disable-next-line
      return this.db.collection("governance").doc(this.getCompanyDID).collection("engineering");
    },
    dbCompanyEngineeringHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getCompanyDID).collection("engineering");
    },
    dbCompanyFacility() {
      // definsive tets for sign in.
      let did = "sign in";
      if (this.getCompanyDID !== null) {
        did = this.getCompanyDID;
      }
      // eslint-disable-next-line
      return this.db.collection("governance").doc(did).collection("facility");
    },
    dbFacilityAsset() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("asset");
    },
    dbFacilityNotification() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("notification");
    },
    dbFacilityResult() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("result");
    },
    dbFacilityResultDetails() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("result");
    },
    dbFacilityMaintenancePlan() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("maintenance");
    },
    dbFacilityWork() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("work");
    },
    dbFacilityWorkHistory() {
      // eslint-disable-next-line
      return this.db.collection("history").doc(this.getFacilityDID).collection("work");
    },
    dbFacilityProcedure() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("procedure");
    },
    dbFacilityResource() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("resource");
    },
    dbFacilityAccess() {
      // eslint-disable-next-line
      return this.db.collection("management").doc(this.getFacilityDID).collection("access");
    },
    dbFacilityLog() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getFacilityDID).collection("log");
    },
    dbAssetLog() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.getAssetDID).collection("log");
    },
    dbAssetResult() {
      // eslint-disable-next-line
      return this.db.collection("asset").doc(this.getAssetDID).collection("result");
    },
    dbAssetTree() {
      // eslint-disable-next-line
      return this.db.collection("relps").doc(this.getAssetDID).collection("a1");
    },
    dbAssetTreeUndefined() {
      // eslint-disable-next-line
      return this.db.collection("relps");
    },
    dbCommsGlobal() {
      // eslint-disable-next-line
      return firebase.firestore().collection("admin").doc("comms").collection("global");
    },
    dbAdminDataPrivacy() {
      // eslint-disable-next-line
      return firebase.firestore().collection("admin").doc("legal").collection("data privacy");
    },
    dbAdminTermsAndConditions() {
      // eslint-disable-next-line
      return firebase.firestore().collection("admin").doc("legal").collection("terms and conditions");
    },
    dbAdminLicence() {
      // eslint-disable-next-line
      return firebase.firestore().collection("admin").doc("licence").collection("subscription");
    },
    dbDocumentRevision() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.detailDID).collection("rev");
    },
    dbDocumentChangeTracker() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.detailDID).collection("track");
    },
    dbDocumentLog() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.logDID).collection("log");
    },
    dbDocumentArchiveCompany() {
      // eslint-disable-next-line
      return firebase.firestore().collection("governance").doc(this.getCompanyDID).collection("archive");
    },
    dbDocumentArchiveFacility() {
      // eslint-disable-next-line
      return firebase.firestore().collection("management").doc(this.getFacilityDID).collection("archive");
    },
    dbDocumentComms() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.detailDID).collection("comms");
    },
    dbDocumentCommsDirect() {
      // eslint-disable-next-line
      return this.db.collection("document").doc(this.directDID).collection("comms");
    },
    dbMaintStrategyFacility() {
      // eslint-disable-next-line
      return firebase.firestore().collection("management").doc(this.getUser.pref.select.cname).collection(this.getUser.select.fname).doc("Maintenance").collection("Strategy");
    },
    dbMaintStrategyCompany() {
      // eslint-disable-next-line
      return firebase.firestore().collection("governance").doc(this.getUser.pref.select.cname).collection("Maintenance Strategy");
    },
    dbMaintAssuranceCompany() {
      // eslint-disable-next-line
      return firebase.firestore().collection("governance").doc(this.getUser.pref.select.cname).collection("Maintenance Assurance");
    },
    dbCompanyMaintStrategy() {
      // eslint-disable-next-line
      return firebase.firestore().collection("governance").doc(this.getUser.pref.select.cname).collection("Maintenance Strategy");
    }
  },
  methods: {
    defineDataSourceFromTag(tag) {
      let db = null;
      if (tag === "U1" || tag === "U1.Dash") {
        db = this.dbUser;
      } else if (tag === "C1" || tag === "C1.Dash") {
        db = this.dbCompany;
      } else if (tag === "F1" || tag === "F1.Dash") {
        db = this.dbCompanyFacility;
      } else if (tag === "A1" || tag === "A1.Dash") {
        db = this.dbFacilityAsset;
      } else if (tag === "A1.A1") {
        // ASSET TREE
        db = this.dbAssetTree;
      } else if (tag === "G4") {
        // Company Roles (User Register);
        db = this.dbCompanyAccess;
      } else if (tag === "G5") {
        // Company Roles (User Register);
        db = this.dbStats;
      } else if (tag === "G6") {
        // Company Roles (User Register);
        db = this.dbRelps;
      } else if (tag === "B1") {
        db = this.dbCompanyRisk;
      } else if (tag === "B1H") {
        db = this.dbCompanyRiskHistory;
      } else if (tag === "B4") {
        db = this.dbCompanyBudget;
      } else if (tag === "B4.Q1") {
        db = this.dbBudgetOrders;
      } else if (tag === "B4H") {
        db = this.dbCompanyBudgetHistory;
      } else if (tag === "B6") {
        db = this.dbCompanyPlan;
      } else if (tag === "B6H") {
        db = this.dbCompanyPlanHistory;
      } else if (tag === "B6.W") {
        db = this.dbCompanyPlanWork;
      } else if (tag === "Q1") {
        db = this.dbCompanyOrder;
      } else if (tag === "Q1H") {
        db = this.dbCompanyOrderHistory;
      } else if (tag === "D1") {
        db = this.dbDocumentRevision;
      } else if (tag === "D2") {
        db = this.dbDocumentChangeTracker;
      } else if (tag === "D3") {
        db = this.dbDocumentLog;
      } else if (tag === "B3") {
        db = this.dbCompanyAction;
      } else if (tag === "B3H") {
        db = this.dbCompanyActionHistory;
      } else if (tag === "U1.B3") {
        db = this.dbUserActions;
      } else if (tag === "O1") {
        db = this.dbFacilityNotification;
      } else if (tag === "W1" || tag === "W2" || tag === "W.TOOL") {
        db = this.dbFacilityWork;
      } else if (tag === "W1H" || tag === "W2H") {
        db = this.dbFacilityWorkHistory;
      } else if (tag === "W6") {
        db = this.dbCompanyProcedure;
      } else if (tag === "E6") {
        db = this.dbCompanyProgram;
      } else if (tag === "W3") {
        db = this.dbFacilityResource;
      } else if (tag === "E2") {
        db = this.dbCompanyEngineering;
      } else if (tag === "E8") {
        db = this.dbFacilityResult;
      } else if (tag === "E8.A1") {
        db = this.dbAssetResult;
      } else if (tag === "E2H") {
        db = this.dbCompanyEngineeringHistory;
      } else if (tag === "E1") {
        db = this.dbCompanyEquipment;
      } else if (tag === "L1") {
        db = this.dbCompanyMaterial;
      } else if (tag === "L1.Q1") {
        db = this.dbMaterialOrders;
      } else if (tag === "L2") {
        db = this.dbCompanyMaterialList;
      } else if (tag === "H1") {
        db = this.dbCompanyHazard;
      } else if (tag === "M2") {
        db = this.dbCompanyMaintenanceStrategy;
      } else if (tag === "M2.M5") {
        db = this.dbMaintenanceStrategyPlans;
      } else if (tag === "M5") {
        db = this.dbFacilityMaintenancePlan;
      } else if (tag === "M7") {
        db = this.dbMaintenanceCall;
      } else if (tag === "S1") {
        db = this.dbCompanyHazard;
      } else if (tag === "S6") {
        db = this.dbCompanyIncident;
      } else if (tag === "S6H") {
        db = this.dbCompanyIncidentHistory;
      } else if (tag === "Z1") {
        db = this.dbAdminDataPrivacy;
      } else if (tag === "Z2") {
        db = this.dbAdminTermsAndConditions;
      } else if (tag === "Z5") {
        db = this.dbAdminReviewAccess;
      } else if (tag === "Z7") {
        db = this.dbCommsGlobal;
      } else if (tag === "Z10") {
        db = this.dbAdminLicence;
      } else {
        db = null;
      }
      return db;
    },
    defineDataSourceFromTagForArchive(tag) {
      let db = null;
      if (tag === "O1" || tag === "M5" || tag === "W1" || tag === "W2") {
        db = this.dbDocumentArchiveFacility;
      } else {
        db = this.dbDocumentArchiveCompany;
      }
      return db;
    },
    defineDataSourceFromTagDirect(tag, did) {
      let db = null;
      this.directDID = did;
      if (tag === "D4") {
        db = this.dbDocumentCommsDirect;
      }
      return db;
    },
    defineSearchOrder(tag) {
      let order = null;
      if (tag === "U1") {
        order = "basic.idg";
      } else if (tag === "D1" || tag === "D2") {
        order = "idg";
      } else {
        order = null;
      }
      return order;
    },
    defineDataSourceFromTagForRelationship(tag, tagd) {
      let db = null;
      // console.log("");
      // console.log("DEFINE DATA SOURCE");
      // console.log(tag);
      // console.log(tagd);
      if (tag === "G1") {
        if (tagd === "U1") {
          // user company or facility
          db = this.dbUserAccess;
        } else if (tagd === "C1") {
          // company users
          db = this.dbCompanyAccess;
        } else if (tagd === "F1") {
          // facility users
          db = this.dbFacilityAccess;
        } else if (tagd === "Z5") {
          db = this.dbAdminReviewAccess;
        }
      } else if (tag === "D3") {
        if (tagd === "U1" || tagd === "U1.Dash") {
          // user company or facility
          db = this.dbUserLog;
        } else if (tagd === "C1" || tagd === "C1.Dash") {
          // company users
          db = this.dbCompanyLog;
          // HELP
          // console.log("COMPANY ACCESS");
          // console.log(this.getCompanyDID);
        } else if (tagd === "F1" || tagd === "F1.Dash") {
          // facility users
          db = this.dbFacilityLog;
        } else if (tagd === "A1" || tagd === "A1.Dash") {
          // facility users
          db = this.dbAssetLog;
          // DOC LOGS
        } else if (
          tagd !== "U1" &&
          tagd !== "C1" &&
          tagd !== "F1" &&
          tagd !== "A1"
        ) {
          db = this.dbDocumentLog;
        }
      } else if (tag === "C1") {
        if (tagd === "U1") {
          db = this.dbCompanyAccess;
        } else if (tagd === "D1") {
          db = this.dbDocumentRevision;
        } else if (tagd === "D2") {
          db = this.dbDocumentChangeTracker;
        } else {
          db = null;
        }
      } else if (tag === "F1") {
        if (tagd === "U1") {
          db = this.dbFacilityAccess;
        } else if (tagd === "D1") {
          db = this.dbDocumentRevision;
        } else if (tagd === "D2") {
          db = this.dbDocumentChangeTracker;
        } else {
          db = null;
        }
      } else {
        db = null;
      }
      // HELP
      // console.log("DEFINE");
      // console.log(tag);
      // console.log(tagd);
      // console.log(db);
      return db;
    }
  }
};
